import React from "react";
import "./CareersSection.css";

export default function CareersTwoColumn({
  videoEmbedUrl = "https://inpelz.com/Careers-video.mp4",
  videoType = "youtube",
}) {
  const mailTo = (position = "") => {
    const subject = encodeURIComponent(`Application - ${position || "Interested Position"}`);
    return `mailto:info@newzealacademy.com?subject=${subject}`;
  };

  return (
    <section className="careers-container">
      <div className="careers-grid">
        <aside className="careers-left">
  <h2>Join Our Team</h2>

  <p>
    At <strong>NewZeal Language Academy</strong>, we believe in the power of
    communication to change lives. We are always looking for passionate,
    skilled, and enthusiastic professionals who want to make a difference.
  </p>
  <ul style={{ color: "#555" }}>
  <li>Share your knowledge with motivated learners</li>
  <li>Be part of a supportive and innovative teaching environment</li>
  <li>Enjoy flexible online opportunities</li>
  <li>Grow with us as we expand pan-India</li>
</ul>
  <p>
    To collaborate with us, fill up and submit the form below or write to <a href="mailto:info@newzealacademy.com">info@newzealacademy.com</a> or call <a href="tel:+919141007452">+91 9141007452</a> 
  </p>

</aside>


        <div className="careers-right">
          {videoType === "youtube" ? (
            <div className="video-wrapper">
              <iframe
                src={videoEmbedUrl}
                title="Career video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          ) : (
            <video controls>
              <source src={videoEmbedUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )}
        </div>
      </div>
    </section>
  );
}
